import {ActorSubclass} from '@dfinity/agent';
import {_SERVICE} from '../declarations/backend/backend.did';
import {createActor, canisterId} from '../declarations/backend';
import {Ed25519KeyIdentity} from '@dfinity/identity';

export namespace BackendActor {
  export async function getBackendActor(
    identity: Ed25519KeyIdentity
  ): Promise<ActorSubclass<_SERVICE>> {
    const backendActor = createActor(canisterId as string, {
      agentOptions: {
        identity,
        host: process.env.BACKEND_CANISTER_HOST || undefined,
      },
    });

    return backendActor;
  }
}
